import { useEffect, useState } from "react";
import useDebouncedPropertyFetch from "./useDebouncedPropertyFetch";

/**
 * Drives the header property dropdown's server-side search.
 * Fetches the first page (limit 20) for the current search text and exposes
 * the matching properties plus the backend's total count.
 *
 * @returns {{
 *   searchText: string,
 *   setSearchText: (text: string) => void,
 *   results: Array<object>,
 *   totalCount: number,
 *   loading: boolean,
 * }}
 */
const usePropertyHeaderSearch = () => {
  const [searchText, setSearchText] = useState("");
  const [results, setResults] = useState([]);
  const [totalCount, setTotalCount] = useState(0);

  const { loading, debouncedFetch } = useDebouncedPropertyFetch((data) => {
    setResults(data?.properties ?? []);
    setTotalCount(data?.totalCount ?? 0);
  });

  // Debounce the search input; the initial run (empty text) loads the
  // default first page and total count.
  useEffect(() => {
    debouncedFetch(searchText);
  }, [searchText, debouncedFetch]);

  return { searchText, setSearchText, results, totalCount, loading };
};

export default usePropertyHeaderSearch;
